'use client';
import { createContext, useContext } from 'react';
// Lets consumers redirect Radix Portal targets (Select, Popover,
// DropdownMenu, Tooltip, Dialog, …) to a specific element instead of
// `document.body`. The motivating case is the embed-popup widget, which
// renders inside a shadow root — Radix's default `document.body` portal
// target lands the popper in the light DOM where the bundled Tailwind
// utilities don't reach, so the popper paints unstyled and stacks
// against the host page instead of the widget's stacking context.
//
// Default `undefined` means "behave as Radix normally does" (portal to
// `document.body`). Patched shadcn primitives in `components/ui/`
// thread this value to their `<X.Portal container={...}>` prop.
export const PortalContainerContext = createContext(undefined);
export function usePortalContainer() {
    return useContext(PortalContainerContext);
}
